import React from 'react';

const Dashboard = () => {
  return (
    <div>
      <p>You Have to select the options on your left side of the website.</p>
    </div>
  );
};

export default Dashboard;